import React, { useState, useEffect } from 'react';

const DIAS_SEMANA = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];

/**
 * Parse previsão string "DD/MM/YYYY HH:mm" (ou "DD/MM/YYYY") para Date.
 * Retorna null se inválido.
 */
function parsePrevisao(previsaoStr) {
  if (!previsaoStr || typeof previsaoStr !== 'string') return null;
  const trimmed = previsaoStr.trim();
  const parts = trimmed.split(/\s+/);
  const datePart = parts[0] || '';
  const timePart = parts[1] || '00:00';
  const [d, m, y] = datePart.split('/').map(Number);
  const [hour, min] = timePart.split(':').map(Number);
  if (!d || !m || !y) return null;
  const date = new Date(y, m - 1, d, hour || 0, min || 0, 0, 0);
  return isNaN(date.getTime()) ? null : date;
}

/**
 * Retorna { dias, horas, minutos } positivos (falta) ou negativos (passou).
 */
function diffFromNow(dueDate) {
  const now = new Date();
  const diffMs = dueDate.getTime() - now.getTime();
  const totalMin = Math.floor(Math.abs(diffMs) / 60000);
  const dias = Math.floor(totalMin / (24 * 60));
  const restMin = totalMin % (24 * 60);
  const horas = Math.floor(restMin / 60);
  const minutos = restMin % 60;
  const sign = diffMs >= 0 ? 1 : -1;
  return {
    dias: sign * dias,
    horas: sign * (horas * 60 + minutos),
    isPast: diffMs < 0,
  };
}

/**
 * Formata "X dia(s)" e "hh:mm" para a segunda linha.
 */
function formatTimeLine({ dias, horas, isPast }) {
  const absDias = Math.abs(dias);
  const totalMin = Math.abs(horas);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  const horasStr = h === 1 ? '1 hora' : `${h} horas`;
  const minutosStr = m === 1 ? '1 minuto' : `${m} minutos`;
  const timeStr = h > 0 && m > 0 ? `${horasStr} e ${minutosStr}` : h > 0 ? horasStr : minutosStr;
  const diasStr = absDias === 0 ? '' : `${absDias} dia(s) `;
  const text = (diasStr + timeStr).trim();
  if (isPast) {
    return { text, label: 'vencido' };
  }
  return { text, label: 'à vencer' };
}

/**
 * Primeira linha: "Vence [dia]", "Vence hoje" ou "Venceu [dia]".
 */
function getVencimentoLine(dueDate, now) {
  const isPast = dueDate.getTime() < now.getTime();
  const dueDay = dueDate.getDate();
  const dueMonth = dueDate.getMonth();
  const dueYear = dueDate.getFullYear();
  const todayDay = now.getDate();
  const todayMonth = now.getMonth();
  const todayYear = now.getFullYear();
  const isToday = dueDay === todayDay && dueMonth === todayMonth && dueYear === todayYear;
  const diaNome = DIAS_SEMANA[dueDate.getDay()];

  if (isPast) {
    return `Venceu ${isToday ? 'hoje' : diaNome}`;
  }
  if (isToday) {
    return 'Vence hoje';
  }
  return `Vence ${diaNome}`;
}

export function OrderDetailsPrevisaoTimer({ previsaoStr, variant }) {
  const isSlaBanner = variant === 'slaBanner';
  const [now, setNow] = useState(() => new Date());

  const dueDate = parsePrevisao(previsaoStr);

  useEffect(() => {
    if (!dueDate) return;
    const interval = setInterval(() => setNow(new Date()), 60000);
    return () => clearInterval(interval);
  }, [previsaoStr]);

  if (!dueDate) return null;

  const diff = diffFromNow(dueDate);
  const vencimentoLine = getVencimentoLine(dueDate, now);
  const { text: timeText, label } = formatTimeLine(diff);

  if (isSlaBanner) {
    return (
      <div className="order-details-previsao-timer order-details-previsao-timer--sla-banner">
        <div className="order-details-previsao-timer-line order-details-previsao-timer-vencimento">
          {vencimentoLine}
          <span className="order-details-previsao-timer-value"> {timeText}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="order-details-previsao-timer">
      <div className="order-details-previsao-timer-line order-details-previsao-timer-vencimento">
        {vencimentoLine}
      </div>
      <div className="order-details-previsao-timer-line order-details-previsao-timer-tempo">
        <span className="order-details-previsao-timer-value">{timeText}</span>
        <span
          className={`order-details-previsao-timer-badge order-details-previsao-timer-badge--${label === 'vencido' ? 'vencido' : 'a-vencer'}`}
        >
          {label}
        </span>
      </div>
    </div>
  );
}
